<template>
  <div :class="{ banner: true, filter: filter }">
    <img
      :style="`width: 100%;object-fit: cover;`"
      :src="img"
      alt="" />
    <div class="cont">
      <div class="cont-tit">{{ title }}</div>
      <div class="cont-sub">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: {
      type: String | Number,
      default: '1.8rem',
    },
    title: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    filter: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.banner {
  position: relative;
  .cont {
    position: absolute;
    left: 20px;
    bottom: 30%;
    z-index: 2;
    &-tit {
      font-weight: 500;
      font-size: 24px;
      color: #ffffff;
      line-height: 28px;
    }
    &-sub {
      font-weight: 400;
      font-size: 10px;
      color: #ffffff;
      opacity: 0.8;
      line-height: 12px;
      letter-spacing: 1px;
    }
  }
}
.filter {
  &::before {
    content: '';
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) 100%
    );
  }
}
/* phone */
@media (max-width: $phone-max-size) {
  img {
    height: 180px;
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  img {
    height: 321px;
  }
}
</style>
